import tw, { styled } from "twin.macro"

export const Wrapper = styled.header`
  ${tw`w-full bg-white border-0 border-b border-solid border-gray font-brandon-grotesque fixed z-20`}
  height: 85px;

  @media (max-width: 640px){
    height: 80px;
    ${tw`flex items-center`}
  }

`;

export const Content = styled.div`
  ${tw`flex items-center justify-between h-full my-0 mx-auto py-4 px-4 sm:px-8 xl:px-0 max-w-screen-xl w-full box-border`}

  img{
    ${tw`block m-0 p-0`}
  }

  .main-logo{
    ${tw`w-11/12 sm:w-full`}
    max-width: 20rem;
  }
`;
